var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "VueModal",
    {
      attrs: {
        "modal-class": "modal modal-lg",
        title: "Edit Profile: We are here to reimagine...",
      },
      model: {
        value: _vm.modalOpen,
        callback: function ($$v) {
          _vm.modalOpen = $$v
        },
        expression: "modalOpen",
      },
    },
    [
      _c("div", [
        _c("div", { staticClass: "mb-12" }, [
          _c("label", { ref: "reimagine", attrs: { for: "reimagine" } }, [
            _vm._v(
              "\n        Finish the following: \"What I'm / What we're here to reimagine...\"\n        "
            ),
            _c("span", { staticClass: "text-sm font-sans-book block" }, [
              _vm._v(
                "\n          240 characters maximum. What is your inspiring vision, mantra, or change you wish to see in the world? Keep this short, sweet, and unique.\n        "
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("textarea", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.form.reimagine,
                expression: "form.reimagine",
              },
              {
                name: "validate",
                rawName: "v-validate",
                value: "max:240",
                expression: "'max:240'",
              },
            ],
            staticClass:
              "w-full mt-3 p-4 overflow-y-scroll border border-black h-48 bg-transparent",
            attrs: { id: "reimagine", name: "reimagine" },
            domProps: { value: _vm.form.reimagine },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.$set(_vm.form, "reimagine", $event.target.value)
              },
            },
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "text-sm font-sans-italic text-gray-dark mt-1" },
            [
              _vm._v(
                "\n        Character count: " +
                  _vm._s(_vm.form.reimagine ? _vm.form.reimagine.length : 0) +
                  "\n      "
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.errors.has("reimagine"),
                  expression: "errors.has('reimagine')",
                },
              ],
              staticClass: "error text-error-red text-lg",
            },
            [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.errors.first("reimagine")) +
                  "\n      "
              ),
            ]
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "flex justify-center" }, [
          _c(
            "button",
            {
              staticClass: "button",
              attrs: { type: "button" },
              on: { click: _vm.update },
            },
            [_vm._v("\n        Update\n      ")]
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }